export default {
  // Common
  common: {
    save: 'सेव करें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    view: 'देखें',
    add: 'जोड़ें',
    search: 'खोजें',
    filter: 'फ़िल्टर करें',
    loading: 'लोड हो रहा है...',
    error: 'त्रुटि',
    success: 'सफलता',
    confirm: 'पुष्टि करें',
    yes: 'हाँ',
    no: 'नहीं',
    close: 'बंद करें',
    back: 'वापस',
    next: 'अगला',
    previous: 'पिछला',
    submit: 'जमा करें',
    reset: 'रीसेट करें',
    clear: 'साफ़ करें',
    select: 'चुनें',
    choose: 'चुनें',
    upload: 'अपलोड करें',
    download: 'डाउनलोड करें',
    export: 'निर्यात करें',
    import: 'आयात करें',
    refresh: 'ताज़ा करें',
    update: 'अपडेट करें',
    create: 'बनाएं',
    remove: 'हटाएं',
    actions: 'कार्य',
    status: 'स्थिति',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    pending: 'लंबित',
    completed: 'पूर्ण',
    total: 'कुल',
    name: 'नाम',
    email: 'ईमेल',
    phone: 'फोन',
    address: 'पता',
    date: 'दिनांक',
    time: 'समय',
    amount: 'राशि',
    price: 'मूल्य',
    quantity: 'मात्रा',
    description: 'विवरण',
    notes: 'टिप्पणी'
  },

  // Navigation
  nav: {
    dashboard: 'डैशबोर्ड',
    members: 'सदस्य',
    membershipPlans: 'सदस्यता योजनाएं',
    payments: 'भुगतान',
    attendance: 'उपस्थिति',
    reports: 'रिपोर्ट',
    trainersPlans: 'ट्रेनर और योजनाएं',
    gymProfile: 'जिम प्रोफ़ाइल',
    settings: 'सेटिंग्स',
    logout: 'लॉग आउट'
  },

  // Dashboard
  dashboard: {
    title: 'डैशबोर्ड',
    welcomeBack: 'फिर से स्वागत है',
    totalMembers: 'कुल सदस्य',
    activeMembers: 'सक्रिय सदस्य',
    monthlyRevenue: 'मासिक आय',
    pendingPayments: 'लंबित भुगतान',
    recentMembers: 'हाल के सदस्य',
    recentPayments: 'हाल के भुगतान',
    monthlyTrends: 'मासिक रुझान',
    quickStats: 'त्वरित आंकड़े',
    viewAll: 'सभी देखें',
    noData: 'कोई डेटा उपलब्ध नहीं',
    revenue: 'आय',
    growth: 'वृद्धि',
    thisMonth: 'इस महीने',
    lastMonth: 'पिछले महीने'
  },

  // Members
  members: {
    title: 'सदस्य',
    addMember: 'सदस्य जोड़ें',
    memberList: 'सदस्य सूची',
    memberDetails: 'सदस्य विवरण',
    editMember: 'सदस्य संपादित करें',
    deleteMember: 'सदस्य हटाएं',
    memberName: 'सदस्य का नाम',
    membershipPlan: 'सदस्यता योजना',
    joinDate: 'शामिल होने की तारीख',
    expiryDate: 'समाप्ति तिथि',
    contactInfo: 'संपर्क जानकारी',
    emergencyContact: 'आपातकालीन संपर्क',
    medicalInfo: 'चिकित्सा जानकारी',
    paymentHistory: 'भुगतान इतिहास',
    attendanceHistory: 'उपस्थिति इतिहास',
    membershipStatus: 'सदस्यता स्थिति',
    renewMembership: 'सदस्यता नवीनीकरण',
    suspendMember: 'सदस्य निलंबित करें',
    searchMembers: 'सदस्य खोजें...',
    filterByPlan: 'योजना के अनुसार फ़िल्टर करें',
    filterByStatus: 'स्थिति के अनुसार फ़िल्टर करें',
    noMembersFound: 'कोई सदस्य नहीं मिला',
    totalMembers: 'कुल सदस्य',
    newMembersToday: 'आज के नए सदस्य',
    expiringThisMonth: 'इस महीने समाप्त हो रहे'
  },

  // Gym Profile
  gymProfile: {
    title: 'जिम प्रोफ़ाइल',
    subtitle: 'अपने जिम की ब्रांडिंग और प्रोफ़ाइल जानकारी प्रबंधित करें',
    gymInfo: 'जिम जानकारी',
    gymName: 'जिम का नाम',
    gymId: 'जिम आईडी',
    gymLogo: 'जिम लोगो',
    currentLogo: 'वर्तमान लोगो',
    uploadNewLogo: 'नया लोगो अपलोड करें',
    removeLogo: 'वर्तमान लोगो हटाएं',
    logoRequirements: 'आवश्यकताएं',
    logoUsage: 'लोगो उपयोग',
    logoAppears: 'आपका लोगो कहां दिखाई देता है:',
    bestPractices: 'सर्वोत्तम प्रथाएं:',
    currencySettings: 'मुद्रा सेटिंग्स',
    currentCurrency: 'वर्तमान मुद्रा',
    selectCurrency: 'नई मुद्रा चुनें',
    chooseCurrency: 'मुद्रा चुनें...',
    languageSettings: 'भाषा सेटिंग्स',
    currentLanguage: 'वर्तमान भाषा',
    selectLanguage: 'नई भाषा चुनें',
    chooseLanguage: 'भाषा चुनें...',
    contactSupport: 'जिम नाम, पता या फोन नंबर अपडेट करने के लिए कृपया सहायता से संपर्क करें।',
    currencyNote: 'आपकी मुद्रा बदलने से आपके जिम में सभी मौद्रिक प्रदर्शन प्रभावित होंगे। यह परिवर्तन केवल आपके जिम को प्रभावित करता है और अन्य जिम को प्रभावित नहीं करता।',
    languageNote: 'आपकी भाषा बदलने से आपके जिम पोर्टल में सभी टेक्स्ट डिस्प्ले प्रभावित होंगे। यह परिवर्तन केवल आपके जिम को प्रभावित करता है और अन्य जिम को प्रभावित नहीं करता।'
  },

  // Messages
  messages: {
    memberAdded: 'सदस्य सफलतापूर्वक जोड़ा गया!',
    memberUpdated: 'सदस्य सफलतापूर्वक अपडेट किया गया!',
    memberDeleted: 'सदस्य सफलतापूर्वक हटाया गया!',
    profileUpdated: 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!',
    logoUploaded: 'लोगो सफलतापूर्वक अपलोड किया गया!',
    logoRemoved: 'लोगो सफलतापूर्वक हटाया गया!',
    currencyUpdated: 'मुद्रा सफलतापूर्वक अपडेट की गई!',
    languageUpdated: 'भाषा सफलतापूर्वक अपडेट की गई!',
    settingsSaved: 'सेटिंग्स सफलतापूर्वक सहेजी गईं!',
    operationFailed: 'ऑपरेशन विफल हुआ। कृपया पुनः प्रयास करें।',
    networkError: 'नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।',
    confirmDelete: 'क्या आप वाकई इस आइटम को हटाना चाहते हैं?',
    confirmLogout: 'क्या आप वाकई लॉग आउट करना चाहते हैं?'
  }
};